import nationalities from 'i18n-nationality';
import en from 'i18n-nationality/langs/en.json';
import es from 'i18n-nationality/langs/es.json';
import de from 'i18n-nationality/langs/de.json';
import fr from 'i18n-nationality/langs/fr.json';
import it from 'i18n-nationality/langs/it.json';

export function useNationalities() {
  nationalities.registerLocale(en);
  nationalities.registerLocale(es);
  nationalities.registerLocale(de);
  nationalities.registerLocale(fr);
  nationalities.registerLocale(it);

  return nationalities;
}
